/*
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

const scrollableProperties = new Set([ "auto", "scroll", "overlay", "hidden" ]);

export function isElementScrollable(element: HTMLElement): boolean {
	const { overflow, overflowX, overflowY } = window.getComputedStyle(element);

	return (
		scrollableProperties.has(overflow) ||
		scrollableProperties.has(overflowX) ||
		scrollableProperties.has(overflowY)
	);
}
